import styled from "styled-components";

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 640px;
  font-family: "Geist", sans-serif;
  color: #181d27;

  .panel-heading {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.2px;
  }

  .panel-subtitle {
    margin: 0;
    padding-top: 4px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .support-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 20px;
  }
`;

export const SupportRow = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px;
  border: 0.909px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  background: #fff;
  font-family: "Geist", sans-serif;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #fafafa;
  }

  &:focus-visible {
    outline: 2px solid #181d27;
    outline-offset: 2px;
  }

  .row-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: #fafafa;
  }

  .row-text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .row-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #181d27;
  }

  .row-description {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .row-chevron {
    flex-shrink: 0;
  }
`;
